<template>

<!-- style="position: absolute;width:0;height:0;border:0;" -->

<div class="wt-wrapper">
  
  <iframe id="weather-iframe" src="https://www.weatherlink.com/embeddablePage/show/7a995c6c79e74399882f588ab9fa08e2/sumary" width="100%"></iframe>
</div>

</template>

<script>


export default {
  name: "TheWeather",
}
</script>


<style scoped>

#weather-iframe{
  height: 337px;
  width: 100%;
  overflow: hidden;
}


</style>